<template>
  <div class="customer-editor">

      <el-form :model="form" :rules="rules" ref="form" v-loading="loading" :label-width="width">

        <div class="editor-card">
          <div class="editor-title">调查信息</div>
          <div class="editor-body">
            <el-row :gutter="0">
<!--              <el-col :span="11">-->

<!--                <el-form-item label="工作单位" :label-width="width" prop="company_name">-->
<!--                  <el-input v-model="form.company_name" autocomplete="off"></el-input>-->
<!--                </el-form-item>-->

<!--                <el-form-item label="职务" :label-width="width">-->
<!--                  <el-select v-model="form.job" filterable placeholder="请选择">-->
<!--                    <el-option v-for="item in jobList" :key="item.value" :label="item.label" :value="item.value"></el-option>-->
<!--                  </el-select>-->
<!--                </el-form-item>-->

<!--                <el-form-item label="婚姻状况" :label-width="width">-->
<!--                  <el-radio v-model="form.marital_status" :label="1">未婚</el-radio>-->
<!--                  <el-radio v-model="form.marital_status" :label="2">已婚</el-radio>-->
<!--                  <el-radio v-model="form.marital_status" :label="0">其它</el-radio>-->
<!--                </el-form-item>-->



<!--              </el-col>-->
<!--              <el-col :span="1">&nbsp;</el-col>-->
<!--              <el-col :span="11">-->

<!--                <el-form-item label="行业" :label-width="width">-->
<!--                  <el-select v-model="form.industry" filterable placeholder="请选择">-->
<!--                    <el-option v-for="item in industryList" :key="item.value" :label="item.label" :value="item.value"></el-option>-->
<!--                  </el-select>-->
<!--                </el-form-item>-->

<!--                <el-form-item label="月收入" :label-width="width">-->
<!--                  <el-select v-model="form.monthly_income" filterable placeholder="请选择">-->
<!--                    <el-option v-for="item in incomeList" :key="item.value" :label="item.label" :value="item.value"></el-option>-->
<!--                  </el-select>-->
<!--                </el-form-item>-->

<!--                <el-form-item label="学历" :label-width="width">-->
<!--                  <el-select v-model="form.education" filterable placeholder="请选择">-->
<!--                    <el-option v-for="item in educationList" :key="item.value" :label="item.label" :value="item.value"></el-option>-->
<!--                  </el-select>-->
<!--                </el-form-item>-->

<!--              </el-col>-->

              <el-col :span="18">

                <el-form-item label="兴趣爱好" :label-width="width">
                  <el-checkbox-group v-model="form.interest">
                    <el-checkbox v-for="(item, index) in interestList" :key="index" :label="item" :value="item"></el-checkbox>
                  </el-checkbox-group>

                </el-form-item>

              </el-col>

              <el-col :span="5">
                <el-form-item label="其它" label-width="50px">
                  <el-input v-model="form.other_interest" autocomplete="off"></el-input>
                </el-form-item>
              </el-col>

              <el-col :span="11">

                <el-form-item label="私车状况" :label-width="width">
                  <el-radio v-model="form.car_count" :label="1">尚未购车</el-radio>
                  <el-radio v-model="form.car_count" :label="2">1台私家车</el-radio>
                  <el-radio v-model="form.car_count" :label="3">2台私家车</el-radio>
                  <el-radio v-model="form.car_count" :label="4">单位配车</el-radio>
                </el-form-item>

                <el-form-item label="主车型" :label-width="width">
                  <el-input v-model="form.car_type" autocomplete="off"></el-input>
                </el-form-item>

              </el-col>
              <el-col :span="1">&nbsp;</el-col>
              <el-col :span="11">

<!--                <el-form-item label="是否已加入汽车俱乐部" label-width="180px">-->
<!--                  <el-radio v-model="form.car_club" :label="1">是</el-radio>-->
<!--                  <el-radio v-model="form.car_club" :label="0">否</el-radio>-->
<!--                </el-form-item>-->

                <el-form-item label="其他车型" :label-width="width">
                  <el-input v-model="form.other_car_type" autocomplete="off"></el-input>
                </el-form-item>

              </el-col>

              <el-col :span="10">

                <el-form-item label="加入社团" :label-width="width">
                  <el-checkbox-group v-model="form.sport_club">
                    <el-checkbox label="1" v-for="(item, index) in sprotClubList" :key="index" :label="item" :value="item"></el-checkbox>
                  </el-checkbox-group>

                </el-form-item>

              </el-col>

              <el-col :span="5">
                <el-form-item label="其它" :label-width="width">
                  <el-input v-model="form.other_sport_club" autocomplete="off"></el-input>
                </el-form-item>
              </el-col>

              <el-col :span="23">

                <el-form-item label="家庭结构" :label-width="width">
                  <el-radio-group v-model="form.family_type">
                    <el-radio :label="1">单身独居</el-radio>
                    <el-radio :label="2">二人世界</el-radio>
                    <el-radio :label="3">三口之家</el-radio>
                    <el-radio :label="4">四代同堂</el-radio>
                    <el-radio :label="5">带保姆</el-radio>
                  </el-radio-group>
                </el-form-item>



              </el-col>

            </el-row>
          </div>

        </div>

<!--        <div class="editor-card my-10">-->
<!--          <div class="editor-title">商务信息</div>-->
<!--          <div class="editor-body">-->

<!--            <el-row :gutter="0">-->
<!--              <el-col :span="11">-->

<!--                <el-form-item label="信息来源">-->
<!--                  <el-select v-model="form.information_source" filterable placeholder="请选择">-->
<!--                      <el-option label="网络" :value="1"></el-option>-->
<!--                      <el-option label="拜访" :value="2"></el-option>-->
<!--                  </el-select>-->
<!--                </el-form-item>-->

<!--                <el-form-item label="信用等级">-->
<!--                  <el-select v-model="form.credit_level" filterable placeholder="请选择">-->
<!--                      <el-option label="一级" :value="1"></el-option>-->
<!--                      <el-option label="二级" :value="2"></el-option>-->
<!--                      <el-option label="三级" :value="3"></el-option>-->
<!--                  </el-select>-->
<!--                </el-form-item>-->

<!--                <el-form-item label="所处阶段">-->
<!--                  <el-select v-model="form.stage" filterable placeholder="请选择">-->
<!--                      <el-option label="售前" :value="1"></el-option>-->
<!--                      <el-option label="售中" :value="2"></el-option>-->
<!--                      <el-option label="售后" :value="3"></el-option>-->
<!--                  </el-select>-->
<!--                </el-form-item>-->


<!--              </el-col>-->
<!--              <el-col :span="1">&nbsp;</el-col>-->
<!--              <el-col :span="11">-->

<!--                <el-form-item label="关系等级">-->
<!--                  <el-select v-model="form.relationship_level" filterable placeholder="请选择">-->
<!--                      <el-option label="已有客户" :value="1"></el-option>-->
<!--                      <el-option label="意向客户" :value="2"></el-option>-->
<!--                      <el-option label="接触客户" :value="3"></el-option>-->
<!--                  </el-select>-->
<!--                </el-form-item>-->

<!--                <el-form-item label="价值评估">-->
<!--                  <el-select v-model="form.value_assessment" filterable placeholder="请选择">-->
<!--                      <el-option label="价值高" :value="1"></el-option>-->
<!--                      <el-option label="价值低" :value="2"></el-option>-->
<!--                  </el-select>-->
<!--                </el-form-item>-->

<!--              </el-col>-->
<!--            </el-row>-->

<!--          </div>-->
<!--        </div>-->


      </el-form>

      <div class="editor-footer">
        <el-button @click="visable = false">取 消</el-button>
        <el-button type="primary" v-if="is_edit&&ERP.isPermission(3004001006)" @click="submitForm('form')">保 存</el-button>
      </div>

  </div>
</template>

<script>

  import Common from './common.js'

  export default {
    name: "personal-basic-editor",
    emits: ['input'],
    props: {
      value: {
        type: Boolean,
        default() {
          return false
        }
      },
      id: {
        type: [Number, String],
        default() {
          return 0
        }
      },
      width: {
        type: String,
        default() {
          return '110px'
        }
      },
      is_edit:{
        type: Boolean,
        default() {
          return true
        }
      }
    },
    data(){
      return{
        visable: this.value,
        loading: false,
        form: this.getFormData({}),
        old_form:this.getFormData({}),
        rules: {},
        industryList: [{"value":"1","label":"证券期货"},{"value":"2","label":"运输"},{"value":"3","label":"银行"},{"value":"4","label":"保险"},{"value":"5","label":"传播"},{"value":"6","label":"体育"},{"value":"7","label":"部队"},{"value":"8","label":"邮电通信"},{"value":"9","label":"IT行业"},{"value":"10","label":"商业零售"},{"value":"11","label":"个体经营"},{"value":"12","label":"制造业"},{"value":"13","label":"旅行服务"},{"value":"14","label":"咨询顾问"},{"value":"15","label":"文艺团体"},{"value":"16","label":"房地产"},{"value":"17","label":"酒店餐饮"},{"value":"18","label":"建筑施工"},{"value":"19","label":"科研教育"},{"value":"20","label":"医疗卫生"},{"value":"21","label":"投资贸易"},{"value":"22","label":"政府公务员"},{"value":"23","label":"其它"}],
        jobList: [{"value":"11","label":"董事长"},{"value":"12","label":"董事"},{"value":"4","label":"执行总经理"},{"value":"14","label":"副总经理"},{"value":"15","label":"总监"},{"value":"5","label":"部门经理"},{"value":"16","label":"主管"},{"value":"6","label":"一般员工"},{"value":"1","label":"厅局级以上"},{"value":"2","label":"处级干部"},{"value":"3","label":"科级干部"},{"value":"34","label":"科员"},{"value":"7","label":"其他"}],
        incomeList: [{"value":"1","label":"500元以下"},{"value":"2","label":"500-1000元"},{"value":"3","label":"1000-2000元"},{"value":"4","label":"2000-3000元"},{"value":"5","label":"3000-5000元"},{"value":"6","label":"3000-5000元"},{"value":"7","label":"5000-8000元"},{"value":"8","label":"8000-10000元"},{"value":"9","label":"10000-20000元"},{"value":"10","label":"20000元以上"}],
        educationList: [{"value":"1","label":"小学"},{"value":"2","label":"初中"},{"value":"3","label":"高中"},{"value":"4","label":"中专"},{"value":"5","label":"大专"},{"value":"6","label":"本科"},{"value":"7","label":"硕士"},{"value":"8","label":"博士"},{"value":"9","label":"其他"}],
        interestList: ['音乐','文学', '摄影', '棋牌', '舞蹈', '旅游', '书法', '绘画', '运动', '收藏', '上网', '其他'],
        sprotClubList: ['乒乓球俱乐部', '羽毛球俱乐部', '篮球俱乐部' ],
      }
    },
    mounted() {
      console.log('other mounted')
      this.getData()
    },
    watch: {
      value(val) {
      	this.visable = val
      },
      visable(val) {
        this.$emit('input', val)
      },
      id(val) {
        if(this.visable) {
          this.getData()
        }
      },
    },
    methods: {
      getFormData(data) {

        let object = {
          id: 0,
          company_name: '',
          job: '',
          marital_status: 0,
          industry: '',
          monthly_income: '',
          education: '',
          interest: [],
          other_interest: '',
          car_count: 0,
          car_club: 0,
          car_type: '',
          other_car_type: '',
          sport_club: [],
          other_sport_club: '',
          family_type: 0,
          information_source: '',
          relationship_level: '',
          credit_level: '',
          value_assessment: '',
          stage: '',
        }

        let newData = Object.assign({}, object, data)

        if(newData.id) {

          newData.industry = newData.industry === 0 ? '' : newData.industry += ''
          newData.monthly_income = newData.monthly_income === 0 ? '' : newData.monthly_income += ''
          newData.education = newData.education === 0 ? '' : newData.education += ''

          newData.interest = newData.interest ? newData.interest.split(',') : []
          newData.sport_club = newData.sport_club ? newData.sport_club.split(',') : []

          if(newData.information_source === 0) newData.information_source = ''
          if(newData.relationship_level === 0) newData.relationship_level = ''
          if(newData.credit_level === 0) newData.credit_level = ''
          if(newData.value_assessment === 0) newData.value_assessment = ''
          if(newData.stage === 0) newData.stage = ''

        }

        return newData
      },

      getData() {

        if(this.id > 0) {
          this.loading = true
          this.$myhttp.get('admin/Customer/getOtherInfo?customer_id='+this.id).then(backdata => {
            let res = backdata.data
            if(res.code == 200) {
              this.form = this.getFormData(res.data || {customer_id: this.id})
              this.old_form = this.getFormData(res.data || {customer_id: this.id})
            } else {
              this.$message.error('获取客户信息出错！');
            }
            this.loading = false
          })
        } else {
          this.form = this.getFormData({})
          this.old_form = this.getFormData({})
        }

      },
      submitForm(formName) {
        let that = this
        this.$refs[formName].validate((valid) => {
          if (valid) {
            let data = Object.assign({}, this.form)
            data.interest = data.interest.join(',')
            data.sport_club = data.sport_club.join(',')

            let old_data = Object.assign({}, this.old_form)
            old_data.interest = old_data.interest.join(',')
            old_data.sport_club = old_data.sport_club.join(',')

            if(JSON.stringify(data) === JSON.stringify(old_data)) {
              this.$message.warning('数据未修改，请修改后再提交！');
              return false;
            }
            data.old_form = JSON.stringify(old_data);

            this.$myhttp.post('admin/Customer/saveOtherInfo', data).then(backdata => {
              let res = backdata.data
              this.$message({
                message: res.msg,
                type: res.code == 200 ? 'success' : 'error'
              })

              this.$Loading.finish();
            });

          } else {
            return false;
          }
        });
      },
    }
  }
</script>

<style lang="scss" scoped="scoped">

  @import "./common.scss";

  .customer-editor{
    height: 70vh;
    overflow-y: scroll;
  }

  .el-checkbox {
    margin-right: 10px;

    .el-checkbox__label {
      margin-left: 5px;
    }
  }

  .el-radio {
    margin-right: 10px;
  }


</style>



// WEBPACK FOOTER //
// src/components/Admin/Customer/other-editor.vue